import { styled } from '@styles'

export const Subtitle = styled.p`
  ${({ theme }) => theme.typography.body}
`
